import { render, staticRenderFns } from "./o-article-bg-video.vue?vue&type=template&id=511b1414"
import script from "./o-article-bg-video.vue?vue&type=script&lang=js"
export * from "./o-article-bg-video.vue?vue&type=script&lang=js"
import style0 from "./o-article-bg-video.vue?vue&type=style&index=0&id=511b1414&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports